import { useEffect, useState } from 'react';

import { useFeatureUsage } from '../store/featureUsageStore';

export function useGetFeaturesUsed() {
	const { isUsingGuestAccess, isUsingPageRestrictions, numberOfUsers, totalPageViews } =
		useFeatureUsage();
	const [numberOfFeaturesUsed, setNumberOfFeaturesUsed] = useState(0);

	useEffect(() => {
		const featuresUsed = [
			isUsingGuestAccess,
			isUsingPageRestrictions,
			numberOfUsers && numberOfUsers > 10,
			totalPageViews && totalPageViews > 2,
		];

		const featuresUsedCount = featuresUsed.filter((feature) => feature).length;
		setNumberOfFeaturesUsed(featuresUsedCount);
	}, [isUsingGuestAccess, isUsingPageRestrictions, numberOfUsers, totalPageViews]);

	return numberOfFeaturesUsed;
}
